module.exports = __webpack_public_path__ + "img/diw_16_DebtCard.825f4b91.png";